export enum AltBusinessIdType {
  DUNS = 'DUNS',
  GIIN = 'GIIN',
  LEI = 'LEI'
}
